import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { IReportListItem } from '../../../modules/API/Reports/models/reportList';
import FileTextIcon from '../../icons/IconLib/FileTextIcon';

interface Props {
    reports: IReportListItem[];
    value: IReportListItem | null;
    onSelect: (report: IReportListItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const ReportSelector: React.FC<Props> = ({
    reports,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    className,
}) => {
    const [t] = useTranslation('selectors');

    return (
        <SearchableSelect<IReportListItem>
            items={reports}
            value={value}
            onSelect={onSelect}
            getKey={(r) => r.RepID}
            getLabel={(r) => (r.Rep_Name ?? '').trim()}
            placeholder={placeholder ?? t('selectors_report_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            leadingIcon={<FileTextIcon />}
            className={className}
            emptyLabel={t('selectors_report_empty')}
        />
    );
};

export default ReportSelector;
